import { RpeInfo } from './RpeInfo';
import { ComboBoxEmpresa } from '../../../../app/app-datahealth/app-search-information-by-date-and-rpe/model/combo-box-empresa';
import { ComboBoxAeroporto } from '../../../../app/app-datahealth/app-search-information-by-date-and-rpe/model/combo-box-aeroporto';

export class RpeTransfer {
    rpeInfo: RpeInfo;
    aeroportos: Array<ComboBoxAeroporto>;
    empresas: Array<ComboBoxEmpresa>;
}